import { useWoAttachmentsAuthorizationEnabled } from '../../feature-flags/useWoAttachmentsAuthorizationEnabled';
import { useActor } from '../authorization/useActor';
import type { AttachmentAccess } from './getAttachmentAccess';
import { getPmScheduleAttachmentAccess } from './getPmAttachmentAccess';
import type { PmScheduleRecord } from './toPmResource';

export const usePmScheduleAttachmentAccess = (
  record: PmScheduleRecord
): AttachmentAccess =>
  getPmScheduleAttachmentAccess({
    actor: useActor(),
    record,
    isEnforced: useWoAttachmentsAuthorizationEnabled(),
  });
